import { objectReduce } from 'fast-loops';
import { cssifyObject } from 'css-in-js-utils';
export default function cssifyKeyframeRule(frames) {
  return objectReduce(frames, function (css, frame, percentage) {
    return "".concat(css).concat(percentage, "{").concat(cssifyObject(frame), "}");
  }, '');
}